"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCyclesInGraph = exports.getCycleNodesInGraph = exports.makeGraphFromEdges = void 0;
const ts_necessities_1 = require("@glideapps/ts-necessities");
function makeGraphFromEdges(edges) {
    const nodes = new Set();
    for (const [n, outs] of edges) {
        nodes.add(n);
        for (const o of outs) {
            nodes.add(o);
        }
    }
    return {
        getAllNodes() {
            return nodes;
        },
        getAdjacentNodes(n) {
            var _a;
            return (_a = edges.get(n)) !== null && _a !== void 0 ? _a : [];
        },
    };
}
exports.makeGraphFromEdges = makeGraphFromEdges;
// Returns `undefined` if the graph contains no cycles.
function getCycleNodesInGraph(graph) {
    const nodes = new Set(graph.getAllNodes());
    const outEdges = new Map();
    for (const n of nodes) {
        const outs = graph.getAdjacentNodes(n);
        outEdges.set(n, new Set(outs));
    }
    const inEdges = new ts_necessities_1.DefaultMap(() => new Set());
    for (const [n, outs] of outEdges) {
        for (const o of outs) {
            inEdges.get(o).add(n);
        }
    }
    function inDegree(n) {
        return inEdges.get(n).size;
    }
    function outDegree(n) {
        var _a, _b;
        return (_b = (_a = outEdges.get(n)) === null || _a === void 0 ? void 0 : _a.size) !== null && _b !== void 0 ? _b : 0;
    }
    function removeNode(n) {
        var _a, _b;
        const outs = (_a = outEdges.get(n)) !== null && _a !== void 0 ? _a : [];
        const ins = inEdges.get(n);
        for (const o of outs) {
            inEdges.get(o).delete(n);
        }
        for (const i of ins) {
            (_b = outEdges.get(i)) === null || _b === void 0 ? void 0 : _b.delete(n);
        }
        nodes.delete(n);
    }
    while (nodes.size > 0) {
        const toRemove = Array.from(nodes).filter(n => inDegree(n) === 0 || outDegree(n) === 0);
        if (toRemove.length === 0) {
            return nodes;
        }
        for (const n of toRemove) {
            removeNode(n);
        }
    }
    return undefined;
}
exports.getCycleNodesInGraph = getCycleNodesInGraph;
function getCyclesInGraph(graph, cycleNodes) {
    const nodesRemaining = new Set(cycleNodes);
    const cycles = [];
    while (nodesRemaining.size > 0) {
        let n = (0, ts_necessities_1.defined)(Array.from(nodesRemaining)[0]);
        const nodesVisited = [n];
        for (;;) {
            const adjacent = graph.getAdjacentNodes(n);
            const next = Array.from(adjacent).find(a => nodesRemaining.has(a));
            if (next === undefined) {
                nodesRemaining.delete(n);
                break;
            }
            const index = nodesVisited.indexOf(next);
            if (index >= 0) {
                const cycle = nodesVisited.slice(index);
                for (const x of cycle) {
                    nodesRemaining.delete(x);
                }
                cycles.push(cycle);
                break;
            }
            else {
                nodesVisited.push(next);
                n = next;
            }
        }
    }
    return cycles;
}
exports.getCyclesInGraph = getCyclesInGraph;
//# sourceMappingURL=index.js.map